import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import CopyrightIcon from "@material-ui/icons/Copyright";
import { keyframes } from "styled-components";
import { loginCall } from "../apiCalls";
import { AuthContext } from "../utils/context/AuthContext/AuthContext";

const Container = styled.div`
  width: 250px;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  justify-content: space-around;
`;
const Input = styled.input`
  width: 100%;
  height: 30px;
  border: none;
  border-radius: 5px;
  text-align: center;
  font-size: 18px;
  &:focus {
    outline: none;
  }
`;

const Shake = keyframes`

0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }


`;

const Button = styled.button`
  width: 70%;
  height: 30px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 500;
  background-color: #31daaf;
  &:hover {
    animation: ${Shake} 0.5s;
    animation-iteration-count: 1;
  }
  &:disabled {
    animation-play-state: paused;
    cursor: not-allowed;
  }
  @media only screen and (max-width: 380px) {
    margin-bottom: 80px;
  }
`;

const Spinner = keyframes`
0%{
       transform: rotateY(0deg);   
   };
100% {
  transform: rotateY(360deg);
}

`;

const Error = styled.h1`
  color: ${(props) => (props.state ? "red" : "green")};
  font-size: 16px;
`;

const Image = styled.img`
  width: 230px;
  height: 200px;
  animation: ${Spinner} 6s alternate infinite;

  &:hover {
    animation-play-state: paused;
    cursor: pointer;
  }
  
`;

const Footer = styled.div`
  position: fixed;
  left: 0;
  bottom: 20px;
  width: 100%;
  color: white;
  text-align: center;
  justify-content: center;
  display: flex;

  @media only screen and (max-width: 767px) {
    width: 100%;
    flex-direction: column;
  }
`;

const Span = styled.span`
  justify-content: center;
  align-items: center;
  display: flex;
`;
const Link = styled.a`
  color: crimson;
  font-weight: 800;
  font-size: 16px;
`;

const User = () => {
  const { user, isFetching, error, dispatch } = useContext(AuthContext);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [username, setUsername] = useState("");

  useEffect(() => {
    if (username.length < 3) {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  }, [username]);

  const handleClick = () => {
    loginCall(
      {
        username,
      },
      dispatch
    );
  };

  return (
    <>
      <Container>
        <Image id="spinner" src="img/Millionaire.png" />
        <Input
          placeholder="Enter your Name*"
          onChange={(e) => setUsername(e.target.value)}
        />
        {error ? (
          <Error state> {error?.response?.data?.message} </Error>
        ) : (
          <Error> {user?.message}</Error>
        )}

        <Button disabled={isButtonDisabled} onClick={handleClick}>
          {isFetching ? "Loading" : "Start Game"}
        </Button>
      </Container>
      <Footer>
        Created with love by &nbsp;
        <Link href="https://www.linkedin.com/in/mahmoud-ayed-111329207">
          &#9825; Mahmoud &#9825;
        </Link>
        <Span>
          &nbsp; <CopyrightIcon />
          2023 All rights reserved.
        </Span>
      </Footer>
    </>
  );
};

export default User;
